export function shelfPictureSlider() {
    let $sliderConntainer = $(".shelf-picture-slider");

    $sliderConntainer.each(function () {
        let slider = $(this);

        slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            speed: 500,
            fade: true,
            autoplay: true,
            autoplaySpeed: 5000,
            arrows: true,
            dots: true,
        });
    });
};


// WEBPACK FOOTER //
// ./assets/js/modules/shelfPictureSlider.js